import { useQuery } from '@tanstack/react-query';
import { fetchShipmentItrackStatusType } from '../data-provider/shipment-itrack-status-type';

export const useGetShipmentItrackStatusType = () => {
  return useQuery({
    queryKey: ['shipment-itrack-status-type'],
    queryFn: () => fetchShipmentItrackStatusType(),
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });
};
